import useToastContext from "hooks/useToastContext";
import QuestionSubmissionView from "pages/test_manager/components/QuestionSubmissionView";
import GeneralSubmissionInfo from "pages/test_manager/components/SubmissionInfo";
import TestGeneralInfo from "pages/test_manager/components/TestGeneralInfo";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { apiGet, apiPut } from "utils/apiFetch";
import apiPath from "utils/apiPath";

export default function SubmissionDetailsPage() {
  const notifications = useToastContext();
  const { id } = useParams();
  const navigation = useNavigate();
  const [submission, setSubmission] = useState(null);
  const { t } = useTranslation();

  const fetchSubmission = useCallback(async () => {
    try {
      const path = apiPath.quizTestSubmissions + "/" + id;
      const { data } = await apiGet(path);
      setSubmission(data?.results);
    } catch (error) {
      console.log(error);
      notifications.error(error?.response?.data?.results);
    }
  }, [id, notifications]);

  useEffect(() => {
    fetchSubmission();
  }, [fetchSubmission]);

  async function updateAnswerHandler(answer, isCorrect) {
    try {
      const path =
        apiPath.quizTestSubmissions + "/" + id + "/answer/" + answer?._id;
      const result = await apiPut(path, {
        isCorrect: isCorrect,
        pointsEarned: answer?.questionId?.points,
      });
      if (result?.status === 200) {
        notifications.success(t("O_ANSWER_UPDATED_SUCCESSFULLY"));
        fetchSubmission();
      }
    } catch (error) {
      console.log(error);
      notifications.error(error?.response?.data?.message);
    }
  }

  async function markAsGradedHandler(submissionId, isGraded) {
    try {
      const path = apiPath.quizTestSubmissions + "/" + submissionId;
      const result = await apiPut(path, {
        gradedAt: isGraded ? null : new Date(),
        status: isGraded ? "pending" : "graded",
      });
      if (result?.status === 200) {
        notifications.success("Submission Updated Successfully");
        fetchSubmission();
      }
    } catch (error) {
      console.log(error);
      notifications.error(error?.response?.data?.message);
    }
  }

  return (
    <div className="bg-white px-3 py-4 ">
      <h1 className="text-2xl font-bold">{t("O_SUBMISSION_DETAILS")}</h1>
      <hr className="my-4" />

      <GeneralSubmissionInfo
        submission={submission}
        markAsGradedHandler={markAsGradedHandler}
      />
      <hr className="my-4" />

      <TestGeneralInfo test={submission?.quizId} />

      <hr className="my-4" />

      <QuestionSubmissionView
        submission={submission}
        updateAnswerHandler={updateAnswerHandler}
      />
      <hr className="my-4" />
      {/* <div>
        <h2 className="text-lg font-bold">{t("O_ANSWERS")}</h2>
        <div className="flex flex-col gap-4 overflow-x-auto">
          <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th className="py-3 px-6">{t("O_QUESTION_TITLE")}</th>
                <th className="py-3 px-6">{t("O_QUESTION_DESCRIPTION")}</th>
                <th className="py-3 px-6">{t("O_POINTS_EARNED")}</th>
                <th className="py-3 px-6">{t("O_TOTAL_POINTS")}</th>
                <th className="py-3 px-6">{t("O_IS_CORRECT")}</th>
                <th className="py-3 px-6">{t("O_TEXT_ANSWER")}</th>
                <th className="py-3 px-6">{t("O_EXPECTED_ANSWER")}</th>
                <th className="py-3 px-6">{t("O_ACTION")}</th>
              </tr>
            </thead>
            <tbody>
              {submission?.answers?.map((answer, index) => (
                <tr key={index}>
                  <td className="py-3 px-6">{answer?.questionId?.title}</td>
                  <td className="py-3 px-6">
                    {answer?.questionId?.description || "N/A"}
                  </td>
                  <td className="py-3 px-6">{answer?.pointsEarned}</td>
                  <td className="py-3 px-6">{answer?.questionId?.points}</td>
                  <td className="py-3 px-6">
                    {typeof answer?.isCorrect === "boolean" ? (
                      answer?.isCorrect ? (
                        <BiCheck color="green" />
                      ) : (
                        <MdClose color="red" />
                      )
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td className="py-3 px-6">{answer?.textAnswer || "N/A"}</td>
                  <td className="py-3 px-6">
                    {answer?.questionId?.expectedAnswer || "N/A"}
                  </td>
                  <td className="py-3 px-6">
                    {!answer?.isCorrect ? (
                      <Button
                        onClick={() => updateAnswerHandler(answer, true)}
                        color="success"
                        size="small"
                        variant="contained"
                        className="whitespace-nowrap"
                      >
                        {t("O_MARK_AS_CORRECT")}
                      </Button>
                    ) : (
                      <Button
                        onClick={() => updateAnswerHandler(answer, false)}
                        color="error"
                        size="small"
                        className="whitespace-nowrap"
                        variant="contained"
                      >
                        {t("O_MARK_AS_INCORRECT")}
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div> */}
    </div>
  );
}
